"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Typography = require("./Typography.style");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["children", "component"],
    _excluded2 = ["children", "component"],
    _excluded3 = ["children", "component"],
    _excluded4 = ["children", "component"],
    _excluded5 = ["children", "component"],
    _excluded6 = ["children", "component"],
    _excluded7 = ["children", "component"],
    _excluded8 = ["children", "component"],
    _excluded9 = ["children", "component"],
    _excluded10 = ["children", "component"],
    _excluded11 = ["children", "component"],
    _excluded12 = ["children", "component"],
    _excluded13 = ["children", "component"];

var Typography = function Typography(_ref) {
  var children = _ref.children,
      component = _ref.component,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Typography.StyledParagraph, (0, _extends2["default"])({
    as: component
  }, props), children);
};

Typography.propTypes = {
  children: _propTypes["default"].node,
  component: _propTypes["default"].string
};

Typography.BodyLight = function (_ref2) {
  var children = _ref2.children,
      component = _ref2.component,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_Typography.StyledBodyLight, (0, _extends2["default"])({
    as: component
  }, props), children);
};

Typography.BodyLight.propTypes = {
  children: _propTypes["default"].node,
  component: _propTypes["default"].string
};

Typography.BodySmall = function (_ref3) {
  var children = _ref3.children,
      component = _ref3.component,
      props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(_Typography.StyledBodySmall, (0, _extends2["default"])({
    as: component
  }, props), children);
};

Typography.BodySmall.propTypes = {
  children: _propTypes["default"].node,
  component: _propTypes["default"].string
};

Typography.BodySemiBold = function (_ref4) {
  var children = _ref4.children,
      component = _ref4.component,
      props = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  return /*#__PURE__*/_react["default"].createElement(_Typography.StyledSemiBold, (0, _extends2["default"])({
    as: component
  }, props), children);
};

Typography.BodySemiBold.propTypes = {
  children: _propTypes["default"].node,
  component: _propTypes["default"].string
};

Typography.CaptionText = function (_ref5) {
  var children = _ref5.children,
      component = _ref5.component,
      props = (0, _objectWithoutProperties2["default"])(_ref5, _excluded5);
  return /*#__PURE__*/_react["default"].createElement(_Typography.StyledCaptionText, (0, _extends2["default"])({
    as: component
  }, props), children);
};

Typography.CaptionText.propTypes = {
  children: _propTypes["default"].node,
  component: _propTypes["default"].string
};

Typography.LabelText = function (_ref6) {
  var children = _ref6.children,
      component = _ref6.component,
      props = (0, _objectWithoutProperties2["default"])(_ref6, _excluded6);
  return /*#__PURE__*/_react["default"].createElement(_Typography.StyledLabelText, (0, _extends2["default"])({
    as: component
  }, props), children);
};

Typography.LabelText.propTypes = {
  children: _propTypes["default"].node,
  component: _propTypes["default"].string
};

Typography.Placeholder = function (_ref7) {
  var children = _ref7.children,
      component = _ref7.component,
      props = (0, _objectWithoutProperties2["default"])(_ref7, _excluded7);
  return /*#__PURE__*/_react["default"].createElement(_Typography.StyledPlaceholder, (0, _extends2["default"])({
    as: component
  }, props), children);
};

Typography.Placeholder.propTypes = {
  children: _propTypes["default"].node,
  component: _propTypes["default"].string
};

Typography.HelperText = function (_ref8) {
  var children = _ref8.children,
      component = _ref8.component,
      props = (0, _objectWithoutProperties2["default"])(_ref8, _excluded8);
  return /*#__PURE__*/_react["default"].createElement(_Typography.StyledHelperText, (0, _extends2["default"])({
    as: component
  }, props), children);
};

Typography.HelperText.propTypes = {
  children: _propTypes["default"].node,
  component: _propTypes["default"].string
};

Typography.ButtonText = function (_ref9) {
  var children = _ref9.children,
      component = _ref9.component,
      props = (0, _objectWithoutProperties2["default"])(_ref9, _excluded9);
  return /*#__PURE__*/_react["default"].createElement(_Typography.StyledButtonText, (0, _extends2["default"])({
    as: component
  }, props), children);
};

Typography.ButtonText.propTypes = {
  children: _propTypes["default"].node,
  component: _propTypes["default"].string
};

Typography.H1 = function (_ref10) {
  var children = _ref10.children,
      component = _ref10.component,
      props = (0, _objectWithoutProperties2["default"])(_ref10, _excluded10);
  return /*#__PURE__*/_react["default"].createElement(_Typography.StyledH1, (0, _extends2["default"])({
    as: component
  }, props), children);
};

Typography.H1.propTypes = {
  children: _propTypes["default"].node,
  component: _propTypes["default"].string
};

Typography.H2 = function (_ref11) {
  var children = _ref11.children,
      component = _ref11.component,
      props = (0, _objectWithoutProperties2["default"])(_ref11, _excluded11);
  return /*#__PURE__*/_react["default"].createElement(_Typography.StyledH2, (0, _extends2["default"])({
    as: component
  }, props), children);
};

Typography.H2.propTypes = {
  children: _propTypes["default"].node,
  component: _propTypes["default"].string
};

Typography.H3 = function (_ref12) {
  var children = _ref12.children,
      component = _ref12.component,
      props = (0, _objectWithoutProperties2["default"])(_ref12, _excluded12);
  return /*#__PURE__*/_react["default"].createElement(_Typography.StyledH3, (0, _extends2["default"])({
    as: component
  }, props), children);
};

Typography.H3.propTypes = {
  children: _propTypes["default"].node,
  component: _propTypes["default"].string
};

Typography.DisplayText = function (_ref13) {
  var children = _ref13.children,
      component = _ref13.component,
      props = (0, _objectWithoutProperties2["default"])(_ref13, _excluded13);
  return /*#__PURE__*/_react["default"].createElement(_Typography.StyledDisplayText, (0, _extends2["default"])({
    as: component
  }, props), children);
};

Typography.DisplayText.propTypes = {
  children: _propTypes["default"].node,
  component: _propTypes["default"].string
};
var _default = Typography;
exports["default"] = _default;